import { $host } from ".";

// Get all price lists
export const fetchPriceLists = async () => {
    try {
        const { data } = await $host.get("api/pricelist");
        return data;
    } catch (error) {
        console.error("Error fetching price lists:", error);
        return error;
    }
};

// Get one price list by ID
export const fetchPriceList = async (id) => {
    try {
        const { data } = await $host.get("api/pricelist/" + id);
        return data;
    } catch (error) {
        console.error("Error fetching price list:", error);
        return error;
    }
};

// Create new price list (with file upload support)
export const createPriceList = async (priceList) => {
    try {
        const { data } = await $host.post("api/pricelist", priceList, {
            headers: {
                "Content-Type": "multipart/form-data",
            },
        });
        return data;
    } catch (error) {
        console.error("Error creating price list:", error);
        return error;
    }
};

// Update price list
export const updatePriceList = async (id, priceList) => {
    try {
        const { data } = await $host.put("api/pricelist/" + id, priceList, {
            headers: {
                "Content-Type": "multipart/form-data",
            },
        });
        return data;
    } catch (error) {
        console.error("Error updating price list:", error);
        return error;
    }
};

// Delete price list
export const deletePriceList = async (id) => {
    try {
        const { data } = await $host.delete("api/pricelist/" + id);
        return data;
    } catch (error) {
        console.error("Error deleting price list:", error);
        return error;
    }
};

export const updatePriceListFile = async (id, priceList) => {
    try {
        const { data } = await $host.put("api/pricelist/file/update/" + id, priceList, {
            headers: {
                "Content-Type": "multipart/form-data",
            },
        });
        return data;
    } catch (error) {
        console.error("Error updating price list file:", error);
        return error;
    }
}
